/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { logError } from '@gh/core-util';
import { isNil } from 'lodash';
import { Enum, EnumSet } from '../enum';
import { DataMapper } from './data-mapper';
import { DictionaryItemDto } from '../../common-shared-data/dictionaries';

export abstract class EnumDictionaryMapper<T extends Enum<S>, S> implements DataMapper<EnumSet<T>, string> {
  abstract enumeration: T;

  serialize(name: EnumSet<T>): any {
    const value = {
      code: Enum.name(this.enumeration),
      itemCode:  Enum.toValue(this.enumeration, name),
      localization: name,
    };
    if (isNil(value)) {
      logError(`EnumMapper: enumeration value '${String(name)}' cannot be serialized (Enum '${String(Enum.name(this.enumeration))}')`);
    }
    return value;
  }

  deserialize(value: DictionaryItemDto | unknown): EnumSet<T> {
    // @ts-expect-error unknown payload may omit itemCode until narrowed
    const name  = value?.itemCode;
    if (name) {
      return Enum.byValue(this.enumeration, name);
    }
    logError(`EnumMapper: enumeration value '${value}' cannot be deserialized (Enum '${Enum.name(this.enumeration)}')`);

    return name as EnumSet<T>;
  }
}
